<template>
  <div class="body">
    <!-- 国内退件扫描 -->
    <baseBreadcrumb :page="$t('message.domesticReturnScan')" :menu="$t('message.scanningParcel')" />
    <div class="body">
      <div class="search">
        <div class="start">

          <!-- 快递单号 -->
          {{ $t('message.courierNumber') }}
          :
          <div class="item">
            <input type="text" v-model="express_no" onfocus="this.select()" :placeholder="$t('message.courierNumber')"
              @keyup.enter="receiveRefundStore" class="input">

          </div>

          <!-- 按钮 -->
          <div class="item">
            <el-button type="primary" class="entry" @click="receiveRefundStore" v-if="isAuth(295)">{{
      $t("message.entry")
    }}</el-button>
          </div>
        </div>
        <div class="end">
          <span>日期：</span>

          <!-- 开始日期 -->
          <div class="item">
            <el-date-picker v-model="data.dateStart" type="datetime" :placeholder="$t('message.startDate')"
              default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="data.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
              default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!--  签收员选择-->
          <div class="item select">
            <el-select v-model="data.created_by" :placeholder="$t('message.signerSelection')">
              <el-option v-for="item in optionType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--请输入快递单号  -->
          <div class="item">
            <el-input v-model="data.express_no" clearable onfocus="this.select()"
              :placeholder="$t('message.pleaseEnterTheTrackingNumber')">
            </el-input>
          </div>
          <!-- 查询 -->
          <el-button type="primary" @click="search">{{
      $t("message.inquire")
    }}</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  快递单号-->
          <el-table-column align="center" :label="$t('message.courierNumber')" prop="express_no">
          </el-table-column>

          <!--  部门-->
          <el-table-column align="center" :label="$t('message.department')" prop="type_name">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.admin" :key="index">
                {{ item.role[0].organization.name }}
              </p>
            </template>
          </el-table-column>

          <!--  签收员-->
          <el-table-column align="center" :label="$t('message.signForMember')" prop="express_no">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.admin" :key="index">
                {{ item.realname }}
              </p>
            </template>
          </el-table-column>
          <!-- 录入时间 -->
          <el-table-column align="center" :label="$t('message.entryTime')" prop="created_at">
          </el-table-column>

          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <!-- 删除 -->
              <el-button size="small" type="success" class="dark" @click="receiveRefundDelete(scope.row.id)"
                v-if="isAuth(296)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <audio src="@/assets/MP3/template_success.mp3" ref="template_success"></audio>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { optionType, receiveStatus } from "@/utlis/options";

export default {
  data() {
    return {
      tableData: [{}],
      id: 0, // 修改ID
      show: true,
      data: {
        page: 1,
        pageSize: 10,
        created_by: "",
        express_no: "",
      },
      express_no: "",
      total: 0,
      //   包裹详情
      receiveStatus,
      val: "",
      optionVal: "",
      optionType,
    };
  },
  components: {},
  created() {
    this.receiverefundList();
  },
  methods: {
    receiverefundList() {

      this.$api.signInApi.receiverefundList(this.data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },
    // 收货-扫描签收
    receiveRefundStore() {
      this.$api.signInApi
        .receiveRefundStore({ express_no: this.express_no })
        .then((res) => {
          this.$refs.template_success.play(); //播放
          this.$message.success(res.msg);
          this.express_no = ''
          this.receiverefundList();
        });
    },
    // 搜索
    search() {
      this.data.page = 1;
      this.receiverefundList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        type: "",
        express_no: "",
      };
      this.receiverefundList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.receiverefundList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.receiverefundList();
    },
    // 删除
    receiveRefundDelete(id) {
      this.$confirm(
        '确定删除当前快递单号退件记录吗？',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.confirm"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi
            .receiveRefundDelete({ id })
            .then((res) => {
              this.$message.success(res.msg);
              this.receiverefundList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;
  justify-content: space-between;

  .entry {
    background-color: #ffa21d;
    border-color: #ffa21d;
  }

  .start {
    display: flex;
    line-height: 40px;
  }

  .end {
    display: flex;
    line-height: 40px;
  }

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .select {
    width: 140px;
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
      text-align: center;
      padding: 9px 0;
    }
  }
}

.content {
  padding: 0 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}

.input {
  width: 200px;
  height: 38px;
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  padding: 0 10px;
}
</style>